module.exports = __webpack_public_path__ + "img/9F7D30_B69F75_B9B7BE_CB9C4D-256px.99e46624.png";